import { setupUseHistoryState } from 'lib/Hooks/setupUseHistoryState';

/**
 * This type describes all possible states of `useHistoryState`.  Updating it with something other than
 * this type is not allowed.  Consequently, this is the type that useHistoryState will always return.
 *
 * @typedef {{
 *   form: 'signup'
 *   email: string;
 *   agreedToTerms: boolean;
 * } | {
 *   form: 'verifyCode',
 *   email: string;
 * } | {
 *   form: 'signupSuccess',
 * } | undefined} SubscriptionsHistoryState
 */

/**
 * @returns {SubscriptionsHistoryState}
 */
export function getInitialSignupFormState() {
  return {
    form: 'signup',
    email: '',
    agreedToTerms: false,
  };
}

/**
 * @param {string} email
 * @returns {SubscriptionsHistoryState}
 */
export function getInitialVerifyCodeFormState(email) {
  return {
    form: 'verifyCode',
    email,
  };
}

/**
 * @returns {SubscriptionsHistoryState}
 */
export function getInitialSignupSuccessState() {
  return {
    form: 'signupSuccess',
  };
}

/**
 * @param {import('lib/Hooks/setupUseHistoryState').HistoryApi<SubscriptionsHistoryState>} history - pushState/replaceState methods that wrap the functionality of the builtin API.  These returned methods must be used, so that components that consume `useHistoryState` will re-render.
 * @param {SubscriptionsHistoryState} state - The current state
 */
export const useHistoryState = setupUseHistoryState(
  '_newsSubscriptions',
  /** @type {SubscriptionsHistoryState} */ (undefined),
);
